import CategoryTable from '@/components/category/CategoryTable';

export default function Category() {
	return (
		<div className="flex items-center h-full pt-10 flex-col">
			<CategoryTable />
		</div>
	);
}
